import { IPaginatedApiResponse } from '@/Interfaces/ApiResponse/PaginatedApiResponse.interface';
import { IAuditLogChangesResponse } from '@/Interfaces/AuditLogChange.interface';
import { IChangeLogHistoryResponseItem } from '@/Interfaces/ChangeLogHistory.interface';
import {
  CHANGE_LOG_HISTORY_CHANGES_ENDPOINT,
  CHANGE_LOG_HISTORY_ENDPOINT,
  CHANGE_LOG_HISTORY_EXPORT_ENDPOINT,
} from '@/constants/endpoints';
import { SearchChangeLogHistoryPayload } from '@/types/changeLogHistory.types';

import axios from 'axios';

export const fetchChangeLogHistory = async (
  params: SearchChangeLogHistoryPayload,
): Promise<IPaginatedApiResponse<IChangeLogHistoryResponseItem[]>> => {
  const res = await axios.get(CHANGE_LOG_HISTORY_ENDPOINT, { params });
  return res.data;
};

export const exportChangeLogHistory = async (params: SearchChangeLogHistoryPayload): Promise<any> => {
  const res = await axios.get(CHANGE_LOG_HISTORY_EXPORT_ENDPOINT, { params, responseType: 'blob' });
  return res.data;
};

export const fetchAuditLogChanges = async (auditLogId: number): Promise<IAuditLogChangesResponse> => {
  const res = await axios.get(CHANGE_LOG_HISTORY_CHANGES_ENDPOINT(auditLogId));
  return res.data;
};
